import { app } from "../serviceLMS";

export const fetchMyCourse = async ({ page, pageSize, search }) => {
  try {
    const endpoint = `user/api/client-api/users/user-courses`;
    const response = await app.get(endpoint, {
      params: { page, size:pageSize, searchText:search },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
